"use client";

import { useEffect } from "react";

/** Loads SimpleBar CSS after mount so it is not render-blocking in the document head. */
export function LoadDeferredSimplebarStyles() {
  useEffect(() => {
    void import("simplebar-react/dist/simplebar.min.css");
  }, []);
  return null;
}
